/* @flow */
import * as React from 'react';

import Divider from 'components/Divider.jsx';
import Image from 'components/Image.jsx';
import Link from 'components/Link.jsx';
import LinkConstants from 'constants/LinkConstants';
import Row from 'components/Row.jsx';
import Text from 'components/Text.jsx';
import TextWithGlyph from 'components/TextWithGlyph.jsx';
import EventTracking from 'lib/EventTracking';

import './styles/AdminUpgradeInfo.scss';

const valueProps = [
  'Schoolwide rostering',
  'Long messages',
  'Voice calls',
  'Admin management controls',
  'Automatic communication logs',
  'Priority support',
];

function track(key: string) {
  EventTracking.trackKey(`admin_self_serve.info.${key}`);
}

export default function AdminUpgradeInfo() {
  return (
    <div className="AdminUpgradeInfo">
      <Image src={require('assets/images/admin/AdminUpgrade/school.svg')} />
      <div className="AdminUpgradeInfo-container">
        <Row size="small">
          <Text weight="semibold" size="small">
            Remind Plan
          </Text>
        </Row>
        {valueProps.map(v => (
          <Row size="xsmall">
            <TextWithGlyph glyph="check" glyphColor="eclipse" glyphSize="medium">
              {v}
            </TextWithGlyph>
          </Row>
        ))}
        <Row size="small">
          <Link
            target="_blank"
            className="AdminUpgradeInfo-learnMore"
            href={LinkConstants.PLANS}
            onClick={() => track('learn_more.click')}>
            Learn more
          </Link>
        </Row>
        <Row size="small">
          <Divider size="small" />
        </Row>
        <div className="AdminUpgradeInfo-container">
          <Text>
            Do you have a question about Remind Plans?{' '}
            <Link
              target="_blank"
              href={LinkConstants.ZENDESK_PLANS}
              onClick={() => track('help_center.click')}>
              See our Help Center.
            </Link>
          </Text>
        </div>
      </div>
    </div>
  );
}
